// FIXME: use plugin-asset to automatically use the built version of the image
const imgSrc =
 '/build/modules/homepage-getting-started/interactive-step.gif';

function loadImage() {
  document.getElementById('interactiveStepImage')
    .setAttribute('src', imgSrc);
}

if (document.readyState === 'complete') {
  loadImage();
} else {
  window.addEventListener('load', loadImage, false);
}
